import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect} from "react";
import { useDispatch } from "react-redux";
import { getFailedNetgsmSmsReport} from "../../features/admin5/admin5Slice";
import { useSelector } from "react-redux";
import { useState } from "react";
import InputNumberNew from "../../components/shared/input/new/InputNumberNew";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(100% - 60px);
      margin: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        color: ${({theme}) => theme.mainTextColor};
        margin-bottom: 20px;

      }
      .titles{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 10px;
        text-align: center;
        padding-inline: 10px;
        margin-bottom: 20px;
        .title{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
        }
      }
      .list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .list-item{
            width: 100%;
            display: grid;
            grid-template-columns: repeat(6,1fr);
            gap: 10px;
            text-align: center;
            background-color: ${({theme}) => theme.secondaryBgColor};
            border-radius: 10px;
            padding: 15px 10px;
            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                color: ${({theme}) => theme.mainTextColor};
            }
        }
      }

      }
  }
`;

const titles = ["Tarih", "Telefon Numarası", "Operatör Kodu", "Operatör", "Durum", "Hata"]

const SmsRapor = () => {

    const dispatch = useDispatch()
    const {smsReportList} = useSelector(state => state.admin5)

    const [phoneNumber, setPhoneNumber] = useState("")


    useEffect(() => {
      if(phoneNumber.toString().length === 10){
        dispatch(getFailedNetgsmSmsReport({number: phoneNumber}))
      }
      else{
        dispatch(getFailedNetgsmSmsReport({number: ""}))
      }
      }, [dispatch, phoneNumber]);


  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"SMS Rapor"} position="sticky" />
      <div className="content">
        <div className="top-container">
          <InputNumberNew data={phoneNumber} setData={(e) => setPhoneNumber(e.target.value)} name={"phoneNumber"} labelText={"Telefon Numarası"} />
        </div>
        <div className="titles">
            {titles.map((title) => (
                <div key={title} className="title">{title}</div>
            ))}
        </div>
        <div className="list">
            {smsReportList?.$values?.map((item) => (
                <div className="list-item" key={item.id}>
                    <p>{item.deliveredDate}</p>
                    <p>{item.number}</p>
                    <p>{item.operatorCode}</p>
                    <p>{item.operatorText}</p>
                    <p>{item.statusCode} - {item.statusText}</p>
                    <p>{item.errorCode} - {item.errorText}</p>
                </div>
            ))}
        </div>

        {/* {(allYukbulMessagesMobile && allYukbulMessagesMobile?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )} */}
      </div>
    </div>
  </Container>
  )
}

export default SmsRapor